// Merchant-entered local time is always interpreted as India Standard Time.
export function parseSaleEndIST(input) {
  const match = String(input || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);
  if (!match) return NaN;
  const [, yearText, monthText, dayText, hourText, minuteText, secondText = '0'] = match;
  const [year, month, day, hour, minute, second] = [yearText, monthText, dayText, hourText, minuteText, secondText].map(Number);
  if (year < 2000 || month < 1 || month > 12 || day < 1 || hour > 23 || minute > 59 || second > 59) return NaN;
  const utc = Date.UTC(year, month - 1, day, hour, minute, Number(second));
  const check = new Date(utc);
  if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) return NaN;
  return utc - 330 * 60 * 1000;
}

export function saleTimeRemaining(ms) {
  const seconds = Math.max(0, Math.ceil(ms / 1000));
  const pad = n => String(n).padStart(2, '0');
  const days = Math.floor(seconds / 86400);
  return `${days ? `${days}d ` : ''}${pad(Math.floor(seconds % 86400 / 3600))}:${pad(Math.floor(seconds % 3600 / 60))}:${pad(seconds % 60)}`;
}

if (typeof window !== 'undefined' && !customElements.get('clan-sale-header')) {
  class ClanSaleHeader extends HTMLElement {
    connectedCallback() {
      this.rows = [...this.querySelectorAll('[data-sale-end-row]')];
      this.clocks = [...this.querySelectorAll('[data-sale-end-clock]')];
      this.fallbacks = [...this.querySelectorAll('[data-sale-end-fallback]')];
      this.note = this.querySelector('[data-sale-end-error]');
      if (this.dataset.endEnabled !== 'true') return;
      this.deadline = parseSaleEndIST(this.dataset.endAt);
      if (!Number.isFinite(this.deadline)) {
        if (this.note) this.note.hidden = false;
        return;
      }
      this.clocks.forEach(clock => {
        clock.setAttribute('datetime', new Date(this.deadline).toISOString());
        clock.setAttribute('title', `Sale end: ${this.dataset.endAt} IST`);
      });
      this.update();
      if (!this.hidden && this.deadline > Date.now()) this.timer = window.setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() { window.clearInterval(this.timer); }
    update() {
      const remaining = this.deadline - Date.now();
      const starts = Number(this.querySelector('[data-offer-start]')?.dataset.offerStart || 0) * 1000;
      if (remaining <= 0) {
        window.clearInterval(this.timer);
        if (this.dataset.editor === 'true') {
          if (this.note) this.note.hidden = false;
          this.rows.forEach(row => { row.hidden = true; });
          this.fallbacks.forEach(fallback => { fallback.hidden = false; });
        } else {
          this.hidden = true;
          this.closest('.shopify-section')?.setAttribute('hidden', '');
        }
        return;
      }
      const beforeStart = starts > Date.now();
      this.rows.forEach(row => { row.hidden = beforeStart; });
      this.fallbacks.forEach(fallback => { fallback.hidden = !beforeStart; });
      this.clocks.forEach(clock => { clock.textContent = saleTimeRemaining(remaining); });
    }
  }
  customElements.define('clan-sale-header', ClanSaleHeader);
}
